<template>
    <div>
        <router-view></router-view>
    </div>
</template>


<script>
    export default {
        name: "report"
    }
</script>

<style scoped>

</style>